/* Base styles for standalone checkbox inputs */
.gds-checkbox-input {
  height: var(--radio-button-input-height);
  width: var(--radio-button-input-width);
  border: var(--radio-button-input-border-style);
  background-color: var(--radio-button-container-background-color);
  border-radius: var(--checkbox-input-border-radius);

  -moz-appearance: none;
  -webkit-appearance: none;
  -o-appearance: none;
  margin: 0;
  display: inline-block;
  cursor: pointer;
  position: relative;
  vertical-align: middle;
}

/* Focus styles */
.gds-checkbox-input:focus-visible {
  outline: var(--focus-outline);
  outline-offset: var(--focus-outline-offset);
}

/* Hover states */
.gds-checkbox-input:not(:disabled):hover {
    border: var(--radio-button-hover-input-border-style);
}

/* Active (pressed) states */
.gds-checkbox-input:not(:disabled):active {
  border: var(--radio-button-active-input-border-style);
}

/* Checked states with custom checkmarks */
.gds-checkbox-input:checked {
  background-color: var(
    --radio-button-selected-input-background-color,
    #3b82f6
  );
  border: var(--radio-button-checked-input-border-style);
  position: relative;
}

/* Checkbox checkmark (GDS icon) */
.gds-checkbox-input:checked::after {
  font-family: geico;
  content: "\e158";
  position: absolute;
  left: 0.4rem;
  top: 0.4rem;
  height: var(--radio-button-selected-input-checkmark-height);
  width: var(--radio-button-selected-input-checkmark-width);
  color: var(--radio-button-active-container-background-color);
  background-color: transparent;
  pointer-events: none;
}

/* Disabled states */
.gds-checkbox-input:disabled {
  border: var(--radio-button-disabled-input-border-style);
  background-color: var(
    --radio-button-disabled-container-background-color,
    #f9fafb
  );
  cursor: not-allowed;
  opacity: 0.6;
}

.gds-checkbox-input:disabled:checked {
  background-color: var(
    --radio-button-disabled-checked-container-background-color,
    #e5e7eb
  );
}

.gds-checkbox-input:disabled:checked::after {
  color: var(--radio-button-disabled-container-background-color);
}

/* Error states */
.gds-checkbox-input.gds-error,
.gds-checkbox-input[data-error="true"] {
  border: var(--radio-button-error-input-border-style);
  background-color: var(--radio-button-error-input-background-color);
}

/* Label styling for proper alignment and spacing */
label:has(.gds-checkbox-input) {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-s);
  cursor: pointer;
  user-select: none;
}
